import { AdminInitialState } from "./adminTypes";
import {
  AdminApplicantDeclineState,
  AdminApplicantState,
  ApplicantDocumentState,
  ApplicationDateState,
  AssessmentAuditsState,
  DasboardState,
} from "../models";

export const initialState: AdminInitialState = {
  applicantState: {} as AdminApplicantState,
  applicationDatesState: {} as ApplicationDateState,
  assessmentAuditsState: {} as AssessmentAuditsState,
  adminApplicantDeclineState: {} as AdminApplicantDeclineState,
  applicantDocumentState: {} as ApplicantDocumentState,
  dashboardState: {} as DasboardState,
  exportState: {
    status: 'idle',
    error: null,
    isExporting: false
  }
};